import { CSSProperties } from '@emotion/serialize';
import { ThemeOptions, Shadows } from '@naruto/naruto-theme/src/types';
import Palette from './Global/Palette';
import Typography from './Global/Typography';
import BreakPoint from './BreakPoint';
import ShadowsConfig from './Shadows';
import Button from './Component/Button';
import CssBaseline from './Component/CssBaseline';
import App from './Component/App';
import TextField from './Component/TextField';
import LinearProgress from './Component/LinearProgress';
import Drawer from './Component/Drawer';
import Avatar from './Component/Avatar';
import List from './Component/List';
import SvgIcon from './Component/SvgIcon';
import Tab from './Component/Tab';
import Tabs from './Component/Tabs';
import Paper from './Component/Paper';
import Divider from './Component/Divider';
import TablePagination from './Component/TablePagination';
import PopOver from './Component/PopOver';
import Menu from './Component/Menu';
import Popper from './Component/Popper';
import DatePicker from './Component/DatePicker';
import Dialog from './Component/Dialog';
import Chip from './Component/Chip';
import Link from './Component/Link';
import Radio from './Component/Radio';
import Switch from './Component/Switch';
import Autocomplete from './Component/Autocomplete';
import Step from './Component/Step';
import Pagination from './Component/Pagination';
import FormControlLabel from './Component/FormControlLabel';
import Checkbox from './Component/Checkbox';
import IconButton from './Component/IconButton';
import Snackbar from './Component/Snackbar';
import Breadcrumbs from './Component/Breadcrumbs';

const theme: ThemeOptions = {
  spacing: 4,
  breakpoints: BreakPoint,
  palette: Palette,
  typography: Typography,
  shadows: ShadowsConfig as Shadows,
  components: {
    ...(Button as CSSProperties),
    ...CssBaseline,
    ...App,
    ...TextField,
    ...LinearProgress,
    ...Drawer,
    ...Avatar,
    ...List,
    ...(SvgIcon as CSSProperties),
    ...Tab,
    ...Tabs,
    ...Paper,
    ...(Divider as CSSProperties),
    ...(TablePagination as CSSProperties),
    ...(PopOver as CSSProperties),
    ...(Menu as CSSProperties),
    ...(Popper as CSSProperties),
    ...(DatePicker as CSSProperties),
    ...(Dialog as CSSProperties),
    ...(Chip as CSSProperties),
    ...(Link as CSSProperties),
    ...(Radio as CSSProperties),
    ...(Switch as CSSProperties),
    ...(Autocomplete as CSSProperties),
    ...(Step as CSSProperties),
    ...(Pagination as CSSProperties),
    ...(FormControlLabel as CSSProperties),
    ...(Checkbox as CSSProperties),
    ...(IconButton as CSSProperties),
    ...(Snackbar as CSSProperties),
    ...(Breadcrumbs as CSSProperties)
  }
};

export default theme;
